<script lang="ts">

    import {listCustomersPaginated} from "$lib/calls/customer";
    import {page} from "$app/stores";
    import {afterNavigate, goto} from "$app/navigation";
    import Pagination from "$lib/components/Pagination.svelte";
    import PageLayout from "$lib/components/PageLayout.svelte";
    import SearchFilter from "$lib/components/SearchFilter.svelte";
    import CustomerCard from "$lib/partials/CustomerCard.svelte";
    import {Spinner} from "flowbite-svelte";

    export let data;
    let loading = true;

    let search = $page.url.searchParams.get('search') || '';

    let currentCustomers = {
        collection: []
    }


    afterNavigate(async (ev) => {
        loading = true
        if(ev.to?.url.pathname === '/clients'){
            currentCustomers = await listCustomersPaginated('pageSize=12&'+$page.url.searchParams.toString())
            loading = false
        }
    })

    let setSearch = async value => {
        $page.url.searchParams.set(`search`, value)
        await goto('/clients?' + $page.url.searchParams.toString())
    }
</script>
<PageLayout title="Kunden">
    <section>
        <SearchFilter bind:search on:enter={ev => setSearch(ev.detail)} on:clear={ev => setSearch('')}></SearchFilter>
        {#if loading}
            <div class="text-center my-5">
                <Spinner/>
            </div>
        {:else}

            {#if currentCustomers.collection.length > 0}
                <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-3 my-5">
                    {#each currentCustomers.collection as customer}
                        <CustomerCard {customer}/>

                    {/each}
                </div>
                <div class="mb-3">
                    <Pagination pagination={currentCustomers} />
                </div>
            {/if}
        {/if}


    </section>
</PageLayout>